// Initial-load placeholder for the message list. Three alternating-aligned
// pill shapes that read as a plausible transcript on first paint. Rendered
// by ThreadBody only when the messages query is on its very first fetch
// for a session — TanStack's `isLoading` is gated to skip background
// refetches, so the shimmer never reappears once we've shown content.

// Chakra `Skeleton` used directly: @kula-ai/components has no Skeleton /
// Shimmer primitive, only `Loader` / `DotsLoader` (spinners). Per repo
// convention, drop to Chakra when kula-ai lacks the primitive.
import { Flex, Skeleton } from '@chakra-ui/react';

const BUBBLES: Array<{
  align: 'flex-start' | 'flex-end';
  widthPct: string;
  heightPx: string;
}> = [
  { align: 'flex-start', widthPct: '70%', heightPx: '52px' },
  { align: 'flex-end', widthPct: '45%', heightPx: '36px' },
  { align: 'flex-start', widthPct: '60%', heightPx: '64px' },
];

export const ThreadBodySkeleton = () => (
  <Flex
    direction="column"
    gap="20px"
    data-test-id="thread-body-skeleton"
    aria-hidden
  >
    {BUBBLES.map((bubble, i) => (
      <Flex key={i} justify={bubble.align}>
        <Skeleton
          h={bubble.heightPx}
          w={bubble.widthPct}
          borderRadius="12px"
          startColor="secondary-50"
          endColor="secondary-100"
        />
      </Flex>
    ))}
  </Flex>
);
